// extracted by mini-css-extract-plugin
export default {"avatar":"avatar_avatar__zja+G","small":"avatar_small__ilz59","avatarImage":"avatar_avatarImage__nLDbu"};